// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Comment-module--cds--assistive-text--0dae1";
export var cdsVisuallyHidden = "Comment-module--cds--visually-hidden--7c574";
export var container = "Comment-module--container--ba06c";
export var fadeout = "Comment-module--fadeout--4f64e";
export var focused = "Comment-module--focused--f7077";
export var hideFeedback = "Comment-module--hide-feedback--a819c";
export var showFeedback = "Comment-module--show-feedback--63dd7";
export var skeleton = "Comment-module--skeleton--c44f9";
export var textarea = "Comment-module--textarea--22f42";